import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { config } from 'src/config/config';
import { navigationService, toastNotificationsService } from 'src/config/rootService';

import { validUuid } from 'src/shared/helpers/uuidValidator';
import { JoinVideoSessionPage } from './JoinVideoSessionPage';

interface MatchParams {
    uuid: string;
}

export const VideoSessionGuard: React.FC<RouteComponentProps<MatchParams>> = ({ match }) => {
    const { uuid } = match.params;

    const handleError = (message: string = config.messages.genericError) => {
        toastNotificationsService.renderErrorToast(message);
        navigationService.navigate('/');

        return null;
    };

    if (validUuid(uuid)) {
        return <JoinVideoSessionPage sessionUuid={uuid} />;
    } else {
        return handleError('Could not join video session');
    }
};
